import ReactLoading from "react-loading";
import React from "react";

function Loader() {
    return (
        <ReactLoading color="#6d233e" type='bubbles' height={'20%'} width={'20%'} />
    );
}

export default Loader;